export default "__VITE_ASSET__C4Nl4jtu__"